import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ArticleItem } from '../models/article-item.model';
import { TransportMode } from '../models/transport-mode.enum';
import { LanguageService } from './language.service';
import { LabelType } from '../models/label-type.enum';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {
  constructor(private http: HttpClient, private languageService: LanguageService) { }

  getArticlesList(transportMode: TransportMode, labelType?: LabelType): Observable<ArticleItem[]> {
    let params = new HttpParams().set('transportMode', transportMode);
    if (labelType) {
      params = new HttpParams().set('transportMode', transportMode).set('labelType', labelType);
    }
    return this.http.get<ArticleItem[]>(`${this.languageService.getLanguage()}/Account/Articles/List`, {
      params
    });
  }

  selectArticle(id: number) {
    const params = new HttpParams().set('id', id).set('isArticle', true);
    return this.http.get<ArticleItem[]>(`${this.languageService.getLanguage()}/SmartLabel/DangerousGoodSelected`, {
      params
    });
  }
}
